import React from 'react'


function Error() {
 
  return (
    <div className='error'>
      {/* empty ....it's for only contain space */}
    </div>
  )
}

export default Error




// import React from "react";
// import { useWindupString } from "windups";
// const ThinkingHard = () => {
//   const [text] = useWindupString("I'm thinking really hard.", {
//     pace: (char) => (char === " " ? 600 : 40),
//   });
//   return <div>{text}</div>;
// };


//this is the thing for enabling this 